// ADDED
import React, { useState } from "react";
import OffsetRequestModule from "../../components/modules/OffsetRequest/OffsetRequestModule";
import OffsetRequestHistory from "../../components/modules/OffsetRequest/components/OffsetRequestHistory";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useOffsetRequest } from "../../hooks/useOffsetRequest";
import { LoadingSpinner } from "../../../common/Loading";

function OffsetRequestPage({ user, userAccess, isHideSideMenu }) {
  const [showHistory, setShowHistory] = useState(false);
  const {
    requests, loading, formData, handleInputChange,
    handleSelectEmployee, submitRequest, showMessage, message, isSuccess
  } = useOffsetRequest(user);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace" />
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b flex justify-between items-center">
              <div>
                <div className='sub-title row text-sm'>
                  <span className="text-gray-400">{"Transaction "} &gt; </span>
                  <span className="border-b border-black">{"Offset"}</span>
                </div>
                <h3 className="text-xl font-bold mt-2">Offset Request</h3>
              </div>
              <button onClick={() => setShowHistory(true)} className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer">
                <RemoveRedEyeIcon fontSize="small" className="mr-2" /> VIEW HISTORY
              </button>
            </div>

            <OffsetRequestModule
              user={user} userAccess={userAccess}
              formData={formData} handleInputChange={handleInputChange}
              handleSelectEmployee={handleSelectEmployee}
              submitRequest={submitRequest} showMessage={showMessage}
              message={message} isSuccess={isSuccess} loading={loading}
            />
          </div>
        </div>
      </div>
      <OffsetRequestHistory isOpen={showHistory} onClose={() => setShowHistory(false)} data={requests} />
      <LoadingSpinner loading={loading} />
    </>
  );
}

export default OffsetRequestPage;